import { Component, OnInit, ViewChild } from '@angular/core';
import pq from 'pqgrid';
import { Contract } from '../models/Contract';
import { ListItem } from '../models/ListItem';
import { LocationType } from '../models/Enums';
import { ContractParameters } from '../models/ContractParameters';
import { PqgridComponent } from '../pqgrid/pqgrid.component';
import { ContractDataService } from '../services/contract-data.service';
import { ListDataService } from '../services/list-data.service';
import { UserDataService } from '../services/user-data.service';
import { UserSettingsService } from '../services/user-settings.service';

@Component({
    selector: 'contracts',
    templateUrl: 'contracts.component.html',
    styles: [],
    standalone: false
})
export class ContractsComponent implements OnInit {

    constructor(private _contractData: ContractDataService, private _listDataService: ListDataService, private _userDataService: UserDataService, private _userSettingsService: UserSettingsService) {

    }

    @ViewChild('contractsGrid') contractsGrid: PqgridComponent;
    errorMessage: string = '';
    locList: ListItem[] = [];
    contractList: Contract[] =[];
    recordCount: number = 0;
    contractParameters: ContractParameters = new ContractParameters();
    screenHeight: number = 0;


    contractsColumns = [
        { title: "Contract", width: 100, dataType: "string", dataIndx: "contractNumber", editable: false, filter: { crules: [{ condition: "contain" }] } },
        { title: "Customer", minWidth: 280, dataType: "string", dataIndx: "customerName", editable: false, filter: { crules: [{ condition: "contain" }] } },
        { title: "Origin", minWidth: 280, dataType: "string", dataIndx: "locationName", editable: false, filter: { crules: [{ condition: "contain" }] } },
        { title: "City", width: 100, dataType: "string", dataIndx: "locationCity", editable: false, filter: { crules: [{ condition: "contain" }] } },
        { title: "Market Zone", width: 100, dataType: "string", dataIndx: "pricingZone", editable: false, filter: { crules: [{ condition: "contain" }] } },
        { title: "Comm", width: 60, dataType: "string", dataIndx: "commodityCode", editable: false, filter: { crules: [{ condition: "range" }] } },
        { title: "F/D", width: 60, dataType: "string", dataIndx: "deliveryTerm", editable: false, filter: { crules: [{ condition: "range" }] } },
        { title: "Total Qty", width: 120, dataType: "integer", dataIndx: "quantity", editable: false, filter: { crules: [{ condition: "contain" }] } },
        { title: "Open Qty", width: 120, dataType: "integer", dataIndx: "openQuantity", editable: false, filter: { crules: [{ condition: "contain" }] } },
        { title: "Cont Date", width: 100, dataType: "string", dataIndx: "contractDate", editable: false, filter: { crules: [{ condition: "begin" }] } },
        { title: "Begin Ship", width: 100, dataType: "string", dataIndx: "periodBeginDate", editable: false, filter: { crules: [{ condition: "begin" }] } },
        { title: "End Ship", width: 100, dataType: "string", dataIndx: "periodEndDate", editable: false, filter: { crules: [{ condition: "begin" }] } },
        { title: "Cust Cont", width: 100, dataType: "string", dataIndx: "customerContract", editable: false, filter: { crules: [{ condition: "contain" }] } }
    ];


    options: pq.gridT.options = {
        menuIcon: false,
        showTop: false,
        roundCorners: true,
        reactive: true,
        locale: "en",
        height: "flex",
        fillHandle: "",
        resizable: true,
        numberCell: {
            show: false
        },
        colModel: this.contractsColumns,
        animModel: {
            on: true
        },
        dataModel: {
            data: []
        },
        sortModel: {
            cancel: true,
            type: "local",
            single: true,
            space: false
        },
        filterModel: {
            header: true,
            menuIcon: false
        }
    };

    getOpenContracts() {
        this._contractData.getOpenContracts(this.contractParameters).subscribe({
            next: data => {
                this.contractsGrid.grid.showLoading();
                this.options.height = this.screenHeight * .85;
                this.recordCount = data.length;

                this.contractList = data;
                this.options.dataModel.data = data;
                this.contractsGrid.grid.refresh();

                switch (this.contractParameters.locationType) {
                    case 0:
                        this.contractsColumns[2].title = "Origin";
                        break;
                    case 1:
                        this.contractsColumns[2].title = "Destination";
                        break;
                }
                this.contractsGrid.grid.hideLoading();
                this._userSettingsService.setCurrentLocCode(this.contractParameters.locCode);
            },
            error: err => this.errorMessage = err
        });
    }

    getScreenHeight(): number {
        this.screenHeight = window.innerHeight;
        return this.screenHeight;
    }

    ngOnInit(): void {
        const sessionStoreLocCode = sessionStorage.getItem("locCode");

        this._listDataService.getListItems("loc").subscribe({
            next: data => {
                this.locList = data;
            },
            error: err => this.errorMessage = err
        });

        this._userDataService.getUserSettings().subscribe({
            next: data => {
                if (sessionStoreLocCode === null || sessionStoreLocCode ==="") {
                    this.contractParameters.locCode = data.defaultLocCode;
                } else {
                    this.contractParameters.locCode = sessionStorage.getItem("locCode");
                }
                this.getOpenContracts();
            },
            error: err => this.errorMessage = err
        });

        this.contractParameters.locationType = LocationType.Origin;
        this.getScreenHeight();
    }
}
